import { navLinks } from "@/mocks/chiguaData";

export default function Footer() {
  return (
    <footer className="bg-secondary-100/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-megaphone-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl font-black text-foreground-950">
                吃瓜<span className="text-primary-600">反差</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              神转折、结局意外、剧情神展开与意外收场的集中吃瓜地。悬念先讲，结局后放，
              把每一次反转都留给你亲自揭晓。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">快速跳转</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-950">找我们</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-600">
              <li className="inline-flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" aria-hidden="true"></i>
                投稿 / 商务：tougao@chigua.example
              </li>
              <li className="inline-flex items-center gap-2">
                <i className="ri-refresh-line text-primary-500" aria-hidden="true"></i>
                更新：每日整理新鲜反转瓜
              </li>
              <li className="inline-flex items-center gap-2">
                <i className="ri-earth-line text-primary-500" aria-hidden="true"></i>
                立场：内容仅供娱乐，请勿对号入座
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜反差 · 全网神转折吃瓜基地
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#faq" className="hover:text-primary-600">投稿规则</a>
            <a href="#faq" className="hover:text-primary-600">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}